import { findAll } from './dom.js';

const MARQUEE_SELECTOR = '[data-bp-marquee]';
const TRACK_SELECTOR = '.bp-marquee-track';
const READY_ATTRIBUTE = 'data-bp-marquee-ready';
const SPEED = 45; // px per second; the duration scales with the track length
const MAX_COPIES = 12;
const RESIZE_DELAY = 150;

// Fill the track so the loop stays seamless at any width from 768 up; phones scroll the track by hand instead.
export function fillMarquee(marquee, view = globalThis) {
  const track = marquee.querySelector(TRACK_SELECTOR);
  const base = track?.firstElementChild;
  if (!base || !view.matchMedia('(min-width: 768px)').matches) return 0;

  const target = 2 * marquee.offsetWidth + 2 * base.offsetWidth;
  let added = 0;
  // Copies go in pairs: the keyframe shift calc(-50% - 12px) is seamless only for an even copy count.
  while (track.scrollWidth < target && track.children.length < MAX_COPIES) {
    for (let i = 0; i < 2; i += 1) {
      const copy = base.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
      added += 1;
    }
  }
  track.style.animationDuration = `${((track.scrollWidth / 2 + 12) / SPEED).toFixed(1)}s`;
  return added;
}

export function initializeMarquees(root, view = globalThis) {
  const marquees = findAll(root, MARQUEE_SELECTOR).filter((marquee) => !marquee.hasAttribute(READY_ATTRIBUTE));
  for (const marquee of marquees) {
    marquee.setAttribute(READY_ATTRIBUTE, '');
    fillMarquee(marquee, view);
    let timer;
    view.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => fillMarquee(marquee, view), RESIZE_DELAY);
    });
  }
  return marquees.length;
}
